module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/r9Y1Sa/media/FC-9781398433373.jpg?1692049837617",
      "alt": "This image is the cover for the book Brotherly Love"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Brotherly Love\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Roddy Roan is an intense young man who attends the prestigious Wellington Private School in the Herefordshire countryside. As the dislike of his English teacher Bill Solomons becomes an obsession of revenge, his friends slowly distance themselves from the impending carnage. Solomons turns to his brother for help and circumstances unite them in a common cause, but as each of them battle their own demons, personal tragedy strikes. Justin Kell reluctantly takes on the case of the suspicious disappearance of a city banker and quickly finds himself at the heart of a ruthless crime syndicate. It becomes a race against a time as he puts his life on the line with the stakes even higher when his personal life is turned upside down.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marvin Dixon\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Marvin Dixon’s debut novel, Settlement, was published in 2019 inspired by his experiences in the world of financial services. Thus began the story of Justin Kell a financial journalist and private investigator with a passion for ensuring justice is done. Payback (2021) and Redemption (2022) continued Kell’s story with Brotherly Love being the fourth in the series. Now retired from financial services and focussing on his writing, Marvin Dixon lives in West Yorkshire.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0